// Custom code added - scripts for Showrooms page
function toggleState(element) {
    // expand/collapse state section
  const grid = element.nextElementSibling;
  element.classList.toggle('expanded');
  grid.classList.toggle('expanded');
}

let map;
let geocoder;
let currentInfoWindow = null;
let userMarker = null;
let originalShowroomsList = '';

function initMap() {
  // Center map on the US
  map = new google.maps.Map(document.getElementById('map'), {
    zoom: 4,
    center: { lat: 39.8283, lng: -98.5795 },
    mapTypeId: 'roadmap'
  });

  // Initialize geocoder
  geocoder = new google.maps.Geocoder();

  // Custom pin icon
  const customIcon = {
    url: 'https://maps.google.com/mapfiles/ms/icons/pink-dot.png'
  };

  // Use the showroom data passed from Liquid
  const locations = window.showroomData || [];

  // Add markers for each location
  locations.forEach(location => {
    const marker = new google.maps.Marker({
      position: { lat: location.lat, lng: location.lng },
      map: map,
      title: location.title,
      icon: customIcon
    });

    // Create info window for this marker
    const infoWindow = new google.maps.InfoWindow({
      content: `<div class="mapInfo"><p style="margin-bottom: 5px;"><b>${location.showroom}</b></p><p style="margin: 8px 0px 2px 4px;line-height:20px;">${location.street}<br>${location.city}, ${location.state} ${location.zip}</p><p style="margin: 8px 0px 2px 4px;line-height:20px;">Phone: ${location.phone}<br>Email: ${location.email}<br><a style="margin: 8px 0px 2px 0px;text-decoration:underline;font-weight:600;" target="_blank" href="https://maps.google.com?saddr=Current+Location&daddr=${location.street},${location.city},${location.state},${location.zip}">Get Directions</a></p></div>`
    });

    // Add click event to open info window
    marker.addListener('click', () => {
      if (currentInfoWindow) {
        currentInfoWindow.close();
      }
      infoWindow.open(map, marker);
      currentInfoWindow = infoWindow;
    });

    location.marker = marker;
  });

  // Store locations globally for search functionality
  window.showroomLocations = locations;
  
  // Save original showrooms list HTML
  originalShowroomsList = document.getElementById('showrooms-list').innerHTML;
}

// Calculate distance between two coordinates (in miles)
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 3959;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

// Search for closest showrooms
function searchShowrooms() {
  const address = document.getElementById('address-input').value;
  
  if (!address) {
    alert('Please enter an address');
    return;
  }

  document.getElementById('state-select').value = '';
  geocoder.geocode({ address: address }, (results, status) => {
    if (status === 'OK') {
      const userLocation = results[0].geometry.location;
      const userLat = userLocation.lat();
      const userLng = userLocation.lng();

      if (userMarker) {
        userMarker.setMap(null);
      }

      userMarker = new google.maps.Marker({
        position: userLocation,
        map: map,
        title: 'Your Location',
        icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
      });

      const showroomsWithDistance = window.showroomLocations.map(showroom => {
        const distance = calculateDistance(userLat, userLng, showroom.lat, showroom.lng);
        return { ...showroom, distance: distance };
      });

      const closestShowrooms = showroomsWithDistance
        .filter(showroom => showroom.distance <= 100)
        .sort((a, b) => a.distance - b.distance)
        .slice(0, 10);

      displayResults(closestShowrooms);
      map.setCenter(userLocation);
      map.setZoom(8);
      document.getElementById('reset-button').classList.add('active');

    } else {
      alert('Address not found. Please try again.');
    }
  });
}

// Filter showrooms by state
function filterByState() {
  const selectedState = document.getElementById('state-select').value;
  
  if (!selectedState) {
    resetShowrooms();
    return;
  }

  document.getElementById('address-input').value = '';

  if (userMarker) {
    userMarker.setMap(null);
    userMarker = null;
  }

  const stateShowrooms = window.showroomLocations
    .filter(showroom => showroom.state === selectedState)
    .sort((a, b) => a.city.localeCompare(b.city));

  displayStateResults(stateShowrooms, selectedState);

  if (stateShowrooms.length > 0) {
    const avgLat = stateShowrooms.reduce((sum, s) => sum + s.lat, 0) / stateShowrooms.length;
    const avgLng = stateShowrooms.reduce((sum, s) => sum + s.lng, 0) / stateShowrooms.length;
    
    map.setCenter({ lat: avgLat, lng: avgLng });
    map.setZoom(7);
  }
  document.getElementById('reset-button').classList.add('active');
}

// Display search results
function displayResults(showrooms) {
  const listContainer = document.getElementById('showrooms-list');
  const mapContainer = document.getElementById('map');
  let html = '<div class="state-section">';
  html += '<h2 class="state-title" onclick="toggleState(this)">Closest Showrooms</h2>';
  html += '<ul class="showroom-grid expanded">';
  
  showrooms.forEach((showroom, index) => {
    html += `<li class="showroom-card">
          <a href="${showroom.url}">
          <p class="distance">${showroom.distance.toFixed(1)} miles away</p>
          <p>${showroom.showroom}</p>
          <button class="showroom">Showroom Details</button>
          </a>
        </li>`;
  });
  
  html += '</ul></div>';
  listContainer.innerHTML = html;
  mapContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// Display state filtered results
function displayStateResults(showrooms, stateName) {
  const listContainer = document.getElementById('showrooms-list');
  const searchContainer = document.querySelector('.search-container');
  let html = '<div class="state-section">';
  html += `<h2 class="state-title expanded" onclick="toggleState(this)">${stateName}</h2>`;
  html += '<ul class="showroom-grid expanded">';
  
  showrooms.forEach((showroom) => {
    html += `<li class="showroom-card">
          <a href="${showroom.url}">
          <p>${showroom.showroom}</p>
          <button class="showroom">Showroom Details</button>
          </a>
        </li>`;
  });
  
  html += '</ul></div>';
  listContainer.innerHTML = html;
  searchContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// Reset to original view
function resetShowrooms() {
  const listContainer = document.getElementById('showrooms-list');
  listContainer.innerHTML = originalShowroomsList;
  
  if (userMarker) {
    userMarker.setMap(null);
    userMarker = null;
  }
  
  map.setCenter({ lat: 39.8283, lng: -98.5795 });
  map.setZoom(4);
  document.getElementById('reset-button').classList.remove('active');
  document.getElementById('address-input').value = '';
  document.getElementById('state-select').value = '';
}

// Add event listeners
document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('search-button').addEventListener('click', searchShowrooms);
  document.getElementById('state-select').addEventListener('change', filterByState);
  document.getElementById('reset-button').addEventListener('click', resetShowrooms);
  
  document.getElementById('address-input').addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      searchShowrooms();
    }
  });
});